import Grid from "@mui/material/Grid2";
import { Toggle } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { memo } from "react";

export const Status = memo(() => {
  const { message } = useMessage();

  return (
    <Grid container spacing={8}>
      <Grid size={{ xs: 12 }}>
        <Toggle
          name="active"
          label={message({ id: "active" })}
          data-test-id="campaign-status"
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        {message({ id: "campaignWillStartOnlyIfActive" })}
      </Grid>
    </Grid>
  );
});
